<template>
    <li>
        <video ref="local" autoplay controls></video>
        <p>{{info.type}}</p>
    </li>
</template>

<script>
  export default {
    name: "video-item",
    props: {
      info: {
        type: Object,
        default() {
          return Object.create(null);
        }
      },
    },
    created() {
    },
    mounted() {
      this.$nextTick(() => {
        this.$refs.local.scrObject = this.info.stream;
      });
    }
  }
</script>

<style scoped>

</style>
